import React from "react";
import { trainEventRecordOverview } from "./TrainEventRecordPageSelector";
import { TrainEventRecordSection } from "./TrainEventRecordSection";
import { TrainEventRecordView } from "./TrainEventRecordView";

export const TrainEventRecordSectionOverview = () => {
    return (
        <TrainEventRecordSection
            page={trainEventRecordOverview}
            pageView={TrainEventRecordView.Overview}
        />
    );
};